const LOCATION_TIMEOUT_MS = 20000;
const TARGET_ACCURACY_METERS = 35;

export const getFreshLocationPayload = (required) =>
  new Promise((resolve, reject) => {
    if (!required) {
      resolve({});
      return;
    }

    if (!navigator.geolocation) {
      reject(new Error("Location is required but this browser does not support geolocation."));
      return;
    }

    let bestPosition = null;
    let watchId;
    let settled = false;

    const finish = (position) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeoutId);
      if (watchId !== undefined) navigator.geolocation.clearWatch(watchId);
      resolve({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: Number(position.coords.accuracy),
        capturedAt: new Date(position.timestamp).toISOString(),
      });
    };

    const fail = (error) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeoutId);
      if (watchId !== undefined) navigator.geolocation.clearWatch(watchId);
      const message = error?.code === 1
        ? "Please allow precise location access to continue."
        : "Unable to get a reliable current location. Move near a window, enable precise location, and try again.";
      reject(new Error(message));
    };

    const timeoutId = window.setTimeout(() => {
      if (bestPosition) finish(bestPosition);
      else fail({ code: 3 });
    }, LOCATION_TIMEOUT_MS);

    watchId = navigator.geolocation.watchPosition(
      (position) => {
        const accuracy = Number(position.coords.accuracy);
        if (!bestPosition || accuracy < Number(bestPosition.coords.accuracy)) bestPosition = position;
        if (Number.isFinite(accuracy) && accuracy <= TARGET_ACCURACY_METERS) finish(position);
      },
      (error) => {
        // Permission denial cannot recover; transient timeouts may still be
        // followed by a better reading before our overall timeout expires.
        if (error?.code === 1) fail(error);
      },
      {
        enableHighAccuracy: true,
        timeout: LOCATION_TIMEOUT_MS,
        // Attendance must never reuse the coordinate from an earlier attempt.
        maximumAge: 0,
      },
    );
  });
